import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { awardedForOptions } from '@/module/Nomen/AwardedFor/model/AwardedForModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type AwardedForSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function AwardedForSelectControl<T extends FieldValues>(props: AwardedForSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(awardedForOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
